import React, { useEffect, useRef, useState } from "react";
import styles from "./Blog.module.css";
import BlogCard from "./BlogCard";
import useBlogPosts from "./useBlogPosts";
import useDocumentMeta from "./useDocumentMeta";
import { EmptyState, Spinner } from "../../../components/ui";
import { Reveal, Stagger, StaggerItem } from "../../../components/motion";

const PAGE_SIZE = 9;

const BlogListPage = () => {
  const [page, setPage] = useState(1);
  const { posts, count, loading, failed, reload } = useBlogPosts({
    limit: PAGE_SIZE,
    page,
  });
  const totalPages = Math.max(1, Math.ceil(count / PAGE_SIZE));

  useDocumentMeta(
    "Blog | Gold Loterías",
    "Noticias, planes de premios y guías para jugar las Loterías de Colombia en Gold Loterías."
  );

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  return (
    <div className={styles.page}>
      <Reveal as="header" className={styles.listHeader}>
        <p className={styles.eyebrow}>Blog Gold</p>
        <h1 className={styles.listTitle}>Noticias y guías para jugar</h1>
        <p className={styles.listSubtitle}>
          Planes de premios, consejos y todo lo que necesitas saber sobre las
          Loterías de Colombia.
        </p>
      </Reveal>

      {loading && <Spinner label="Cargando artículos…" />}

      {!loading && posts.length === 0 && (
        <EmptyState
          title="Pronto publicaremos nuevos artículos"
          description={
            failed
              ? "No pudimos cargar el blog en este momento."
              : "Vuelve pronto para leer novedades de Gold Loterías."
          }
          actionLabel={failed ? "Reintentar" : undefined}
          onAction={failed ? reload : undefined}
        />
      )}

      {!loading && posts.length > 0 && (
        <>
          <Stagger key={page} className={styles.grid} stagger={0.06}>
            {posts.map((post) => (
              <StaggerItem key={post.slug} className="motion-fill">
                <BlogCard post={post} />
              </StaggerItem>
            ))}
          </Stagger>

          {totalPages > 1 && (
            <nav className={styles.pagination} aria-label="Páginas del blog">
              <button
                type="button"
                className={styles.pageBtn}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page <= 1}
              >
                Anterior
              </button>
              <span className={styles.pageInfo}>
                Página {page} de {totalPages}
              </span>
              <button
                type="button"
                className={styles.pageBtn}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page >= totalPages}
              >
                Siguiente
              </button>
            </nav>
          )}
        </>
      )}
    </div>
  );
};

export default BlogListPage;
